<template lang="pug">
div(v-if="isPa")
  cadastro-processo-fisico-pa
div(v-else)
  card-financeiro(
    cardTitle="Cadastrar processo físico"
  )
    template(slot="body")
      validation-observer(ref='observer', tag='form', v-slot="{ invalid }")
        form(@submit.prevent="onSubmit")
        el-row.margin-bottom-20(type="flex", :gutter="40")
          el-col(:lg="12")
            validation-provider(rules="required|max:50|numeroProcessoFisico", v-slot="{ errors }", name="número processo")
              app-label(label="Número do processo:", :required="true")
              div(slot="footer", class="dialog-footer")
                el-input.input(
                  v-model="processoFisico.numero",
                  @change="findProcessoAndCompleteForms",
                  maxlength="50",
                  placeholder='0000/000000'
                  v-mask="['####/######']"
                  :class="{'erro' : errors.length}"
                )
                  el-button(slot="append", icon="el-icon-search")
                span.help.erro {{ errors[0] }}

          el-col(:lg="12")
            validation-provider(rules="required", v-slot="{ errors }", name="tipo de processo")
              app-label(label="Tipo de processo:", :required="true")
              el-select.select.input(
                v-model="processoFisico.tipoCadastro.id",
                placeholder="Selecione",
                filterable,
                :disabled="inputDisabled",
                :class="{'erro' : errors.length}"
              )
                el-option(
                  v-for="item in tipoProcessosFiltrados"
                  :key="item.id"
                  :label="item.nome"
                  :value="item.id"
                )
              span.help.erro {{ errors[0] }}

        el-row.margin-bottom-20(type="flex", :gutter="40")
          el-col(:lg="12")
            validation-provider(rules="required|max:100", v-slot="{ errors }", name="nome/razão social do interessado")
              app-label(label="Nome/Razão social do interessado:", :required="true")
              el-input.input(
                v-model="processoFisico.nomeRazaoSocialInteressado",
                :disabled="inputDisabled",
                :class="{'erro' : errors.length}"
              )
              span.help.erro {{ errors[0] }}

          el-col(:lg="12")
            validation-provider(rules="cpf_cnpj", v-slot="{ errors }", name="CPF/CNPJ do interessado")
              app-label(label="CPF/CNPJ do interessado:", :required="true")
              el-input.input(
                v-model="processoFisico.cpfCnpjInteressado",
                v-mask="['###.###.###-##', '##.###.###/####-##']",
                :disabled="inputDisabled",
                :class="{'erro' : errors.length}"
              )
              span.help.erro {{ errors[0] }}

        el-row.margin-bottom-20(type="flex", :gutter="40")
          el-col(:lg="12")
            validation-provider(rules="telefone", v-slot="{ errors }", name="telefone")
              app-label(label="Telefone:", :required="true")
              el-input.input(
                v-model="processoFisico.telefone",
                v-mask="['(##) ####-####', '(##) #####-####']",
                :disabled="inputDisabled"
                :class="{'erro' : errors.length}"
              )
              span.help.erro {{ errors[0] }}

          el-col(:lg="12")
            validation-provider(rules="required|email", v-slot="{ errors }", name="e-mail")
              app-label(label="E-mail:", :required="true")
              el-input.input(
                v-model="processoFisico.email",
                :disabled="inputDisabled",
                :class="{'erro' : errors.length}"
              )
              span.help.erro {{ errors[0] }}

        app-divider.margin-bottom-20(label="Endereço")
        el-row.margin-bottom-20(type="flex", :gutter="40")
          el-col(:lg="12")
            validation-provider(rules="required|max:100", v-slot="{ errors }", name="logradouro")
              app-label(label="Logradouro:", :required="true")
              el-input.input(
                v-model="processoFisico.endereco.logradouro",
                show-word-limit,
                maxlength="100",
                :disabled="inputDisabled",
                :class="{'erro' : errors.length}"
              )
              span.help.erro {{ errors[0] }}

          el-col(:lg="12")
            validation-provider(rules="required", v-slot="{ errors }", name="número")
              app-label(label="Número:", :required="true")
              el-input.input(
                v-model="processoFisico.endereco.numero",
                :disabled="processoFisico.endereco.semNumero || inputDisabled"
                type="number"
                :class="{'erro' : errors.length}"
              )
                el-checkbox.input(
                  v-model="processoFisico.endereco.semNumero",
                  label="S/N", slot="prepend",
                  :disabled="inputDisabled"
                  @change="onSemNumeroCheck"
                )
              span.help.erro {{ errors[0] }}

        el-row.margin-bottom-20(type="flex", :gutter="40")
          el-col(:lg="12")
            app-label(label="Complemento:", :required="false")
            el-input.input(v-model="processoFisico.endereco.complemento", :disabled="inputDisabled")

          el-col(:lg="12")
            validation-provider(rules="required|max:100", v-slot="{ errors }", name="bairro")
              app-label(label="Bairro:", :required="true")
              el-input.input(
                v-model="processoFisico.endereco.bairro",
                :disabled="inputDisabled"
                :class="{'erro' : errors.length}"
              )
              span.help.erro {{ errors[0] }}

        el-row.margin-bottom-20(type="flex", :gutter="40")
          el-col(:lg="12")
            validation-provider(rules="required", v-slot="{ errors }", name="CEP")
              app-label(label="CEP:", :required="true")
              el-input.input(
                v-model="processoFisico.endereco.cep",
                v-mask="'#####-###'",
                :disabled="inputDisabled"
                :class="{'erro' : errors.length}"
              )
              span.help.erro {{ errors[0] }}

          el-col(:lg="12")
            validation-provider(rules="required", v-slot="{ errors }", name="UF")
              app-label(label="UF:", :required="true")
              el-select.select.input(
                v-model="processoFisico.endereco.uf",
                :disabled="true"
                :class="{'erro' : errors.length}"
              )
              span.help.erro {{ errors[0] }}
              el-col(:lg="12")

          el-col(:lg="12")
            validation-provider(rules="required", v-slot="{ errors }", name="município")
              app-label(label="Município:", :required="true")
              el-select.select.input(
                v-model="processoFisico.endereco.municipio.id",
                placeholder="Selecione",
                :filterable="true",
                :disabled="inputDisabled",
                :class="{'erro' : errors.length}"
              )
                el-option(
                  v-for="item in municipios"
                  :key="item.id"
                  :label="item.nome"
                  :value="item.id"
                )
              span.help.erro {{ errors[0] }}

  app-buttons-cadastro(
    :isPrimeiroPasso="true",
    :isUltimoPasso="true",
    :showButtonSalvar="false",
    :isProcessoFisico="true",
    @cancelar="cancelar",
    @finalizar="validateAndSaveOnFinalizar"
  )

</template>

<script>
import { mapActions, mapState } from 'vuex'
import AppLabel from '@/components/AppLabel'
import AppButtonsCadastro from '@/components/AppButtonsCadastro'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import CardFinanceiro from '../components/CardFinanceiro'
import AppDivider from '@/components/AppDivider'
import CadastroProcessoFisicoPa from './para/CadastroProcessoFisicoPa'

export default {
  components: {
    AppLabel,
    AppButtonsCadastro,
    CardFinanceiro,
    AppDivider,
    CadastroProcessoFisicoPa
  },

  mixins: [
    AppNotificacao
  ],

  data () {
    return {
      isPa: process.env.ESTADO === 'pa',
      processoFisico: {
        numero: null,
        tipoCadastro: {
          id: null
        },
        nomeRazaoSocialInteressado: '',
        cpfCnpjInteressado: '',
        telefone: '',
        email: '',
        endereco: {
          logradouro: '',
          numero: null,
          semNumero: false,
          bairro: '',
          complemento: '',
          cep: '',
          municipio: {
            id: null
          },
          uf: this.findEstado()
        }
      },
      inputDisabled: true,
      municipios: []
    }
  },

  async created () {
    this.processoFisico.numero = null
    this.getTiposProcessos()
    this.municipios = await this.getMunicipiosByEstadoAtual()
  },

  computed: {
    ...mapState({
      tiposProcessos: state => state.processos.tiposProcessos,
      municipiosPA: state => state.municipios.municipiosPA
    }),

    tipoProcessosFiltrados () {
      const tiposProcessosExcluidos = ['GENERICO']
      let tiposProcessosFiltrados = this.tiposProcessos.filter(tipoProcesso => !tiposProcessosExcluidos.includes(tipoProcesso.codigo))
      return tiposProcessosFiltrados
    }
  },

  methods: {
    ...mapActions({
      salvarProcessoFisico: 'cadastroProcessoFisico/save',
      getTiposProcessos: 'processos/getTiposProcessos',
      getMunicipiosByEstadoAtual: 'municipios/findMunicipiosByEstadoAtual',
      findProcessoByNumeroProcesso: 'cadastroProcessoFisico/findProcessoByNumeroProcesso'
    }),

    findEstado () {
      return process.env.ESTADO.toUpperCase()
    },
    async findProcessoAndCompleteForms (numeroProcesso) {
      const processo = await this.findProcessoByNumeroProcesso(numeroProcesso)
      this.completeForms(processo, numeroProcesso)

      this.inputDisabled = false
    },
    clearProcessoFisico () {
      return {
        numero: null,
        tipoCadastro: {
          id: null
        },
        nomeRazaoSocialInteressado: '',
        cpfCnpjInteressado: '',
        telefone: '',
        email: '',
        endereco: {
          logradouro: '',
          numero: null,
          semNumero: false,
          bairro: '',
          complemento: '',
          cep: '',
          municipio: {
            id: null
          },
          uf: this.findEstado()
        }
      }
    },

    completeForms (processo, numeroProcesso) {
      if (processo !== null) {
        this.processoFisico = processo
        this.processoFisico.numero = numeroProcesso
        this.processoFisico.endereco.uf = this.findEstado()
        return
      }

      this.processoFisico = this.clearProcessoFisico()
      this.processoFisico.numero = numeroProcesso
    },

    async validateAndSaveOnFinalizar () {
      this.$refs.observer.validate().then(async success => {
        if (!success) {
          return
        }

        this.saveCadastroProcessoFisico()
      })
    },

    async saveCadastroProcessoFisico () {
      try {
        await this.salvarProcessoFisico(this.processoFisico)

        this.successNotification()

        this.$router.push({
          name: 'cof/home'
        })
      } catch (error) {
        this.errorNotification(error)

        throw error
      }
    },

    onSemNumeroCheck (checked) {
      if (checked) {
        this.processoFisico.endereco.numero = 0
        return
      }

      this.processoFisico.endereco.numero = null
    },

    successNotification () {
      this.showNotificacao(
        this.$messages.TIPO_SUCCESS,
        this.$messages.TITULO_SUCCESS,
        this.$messages.DADOS_SALVOS_SUCESSO
      )
    },

    errorNotification (error) {
      this.showNotificacao(
        this.$messages.TIPO_ERROR,
        this.$messages.TITULO_ERROR,
        error.message
      )
    },

    cancelar () {
      this.confirmBox(
        'Você tem certeza que deseja voltar? Todos os dados não salvos serão perdidos.',
        this.$messages.TITULO_WARNING,
        () => { this.$router.push({ name: 'cof/home' }) },
        () => {},
        'Sim',
        'Não'
      )
    }
  }
}
</script>

<style>
.card-header {
  margin-bottom: 20px;
}

.select {
  width:100%
}

.margin-bottom-20 {
  margin-bottom: 20px;
}

.margin-top-50 {
  margin-top: 50px;
}

.container-cadastro {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.el-icon-search {
  color: #009f61;
}

span /deep/ .el-input__count-inner {
  color:#009f61
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance:textfield;
}
</style>



// WEBPACK FOOTER //
// src/screens/financeiro/processoFisico/CadastroProcessoFisico.vue